import { useEffect } from "react";
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { showToast } from "./components/custom/custom-toast";
import { Layout } from "./components/layout/layout";
import { ForgotPasswordPage } from "./features/auth/page/forgot-password-page";
import { LoginPage } from "./features/auth/page/login-page";
import NotFoundPage from "./features/not-found/not-found-page";
import { useFetchData } from "./hooks/useFetch";
import { ConfigsPublicModel } from "./models/response/configs-public";
import { dashboardRouter } from "./routers/app-router";
import { MODULE_ROUTE } from "./routers/module-router";
import { ProtectedRoutes } from "./routers/protected-router";
import { API_CONFIGS_ROUTER, ApiConfig } from "./services/api-config";
import { isSuccess } from "./services/base-response";
import CookieUtils from "./utils/cookie-utils";

const App: React.FC = () => {
  const token = CookieUtils.getCurrentUser().access_token ?? "";
  const { request: fetchGetConfigsPublic, baseResponse: resConfigsPublic } = useFetchData.Get<ConfigsPublicModel>({
    apiPublic: true,
    projectId: ApiConfig.PROJECT_ID.UPLOAD_SERVICE,
  });

  useEffect(() => {
    if (token !== "") {
      fetchGetConfigsPublic({
        endPoint: API_CONFIGS_ROUTER.API_CONFIGS_PUBLIC(),
      });
    }
  }, [token]);

  useEffect(() => {
    if (!resConfigsPublic) return;
    if (isSuccess(resConfigsPublic)) {
      CookieUtils.setCookie("domain", JSON.stringify(resConfigsPublic.data));
    } else {
      showToast({ message: resConfigsPublic.message, type: "warning" });
    }
  }, [resConfigsPublic]);

  return (
    <Router>
      <Routes>
        <Route
          index
          path={MODULE_ROUTE.LOGIN}
          element={token !== "" ? <Navigate replace to={MODULE_ROUTE.COMPANIES} /> : <LoginPage />}
        />
        <Route path={MODULE_ROUTE.FORGOT_PASSWORD} element={<ForgotPasswordPage />} />

        <Route element={<Layout />}>
          <Route element={<ProtectedRoutes />}>
            {dashboardRouter.map((route, index) => (
              <Route key={index} path={route.path} element={route.component} />
            ))}
          </Route>
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
};

export default App;
